var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyingahome20(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 32.9999V24.9999C17 24.2927 17.281 23.6144 17.781 23.1143C18.2811 22.6142 18.9594 22.3333 19.6667 22.3333H22.3333C23.0406 22.3333 23.7189 22.6142 24.219 23.1143C24.719 23.6144 25 24.2927 25 24.9999",
    stroke: "url(#paint0_linear_714_913)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 22.984V21H33L21 9L9 21H11.6667V30.3333C11.6667 31.0406 11.9476 31.7189 12.4477 32.219C12.9478 32.719 13.6261 33 14.3333 33H20.3667M25 30.3333L27.6667 33L33 27.6667",
    stroke: "url(#paint1_linear_714_913)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_714_913",
    x1: 21,
    y1: 22.3333,
    x2: 21,
    y2: 32.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63363A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F4E62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_714_913",
    x1: 21,
    y1: 9,
    x2: 21,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63363A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F4E62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyingahome20);
export default __webpack_public_path__ + "static/media/Buyingahome2.0.95750f087fca0319d74aafd71dfc22ef.svg";
export { ForwardRef as ReactComponent };